import React from 'react';
import { isHostProactive } from '../../../config/ui';

export default class Content extends React.Component {
  render() {
    const { className } = this.props;

    let imageName = "iphoneview";
    let headerName = "Telemetry";
    let headerClass = "txt-color-red";
    let subheaderClass = "";
    let paragraphHeader = "A web application hybrid that extends capabilities of a traditional FFS-based EMR to enable better clinic management through protocols and continual monitoring."
    let paragraphHeaderClass = "paragraph-header";
    let heading = "About Telemetry - The Future of Healthcare Optimization";
    let headingText = "Telemetry gathers a patient's health-related data from a variety of sources and centralizes it into a simple, easy-to-read format for healthcare providers to provide optimal care.";
    let headingClass = "";
    let heading2 = "Multi-source data supporting better health outcomes";
    let heading2Text = "Having access to multiple sourues of data allows healthcare providers the ability to coordinate care more effectively as well as address issues such as cost-containment, gaps in care and polypharmacy.";
    if (isHostProactive())
    {
      imageName = 'iphoneview_piq';
      headerName = 'Proactive IQ';
      headerClass = 'txt-color-customblue';
      subheaderClass = 'txt-color-customblue';
      paragraphHeader = "Proactive IQ integrates clinical, operational, and population health data to empower our teams to fight for our patients' greatest good.";
      paragraphHeaderClass = "paragraph-header-custom";
      heading = "Care Beyond the Walls";
      headingText = "Proactive IQ connects our care teams, clients, and support teams to real - time data insights that enhance our patient experience and drive our care delivery strategies.";
      headingClass = "txt-color-customblack";
      heading2 = "Supporting better health outcomes through integrated data";
      heading2Text = "Integrated data systems enable our teams to identify and address gaps in care and impact health at a population level.";
    }
      
    return (
      <div className={className}>
        <h1 className={`${headerClass} login-header-big`}>{headerName}</h1>
        <div className="hero">
          <div className="pull-left login-desc-box-l">
            <h4 className={`${paragraphHeaderClass}`}>
              {paragraphHeader}
            </h4>
          </div>
          <img
            src={`assets/img/demo/${imageName}.png`}
            className="pull-right display-image"
            alt=""
            style={{ width: '210px' }}
          />
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <h5 className={`${subheaderClass} about-heading`}>
              {heading} &reg;
            </h5>
            <p className={`${headingClass}`}>
              {headingText}
            </p>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <h5 className={`${subheaderClass} about-heading`}>
              {heading2}
            </h5>
            <p className={`${headingClass}`}>
              {heading2Text}
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/components/Content.js